<template>
    <div class="">
        <b-container fluid>
            <h1>HRM Request Query</h1>

            <b-row>
                <b-col cols="12" lg="4">
                  <BaseSelector v-model="criteria.leaveType"
                    :v="$v.criteria.leaveType"
                    slug="leaveType"
                    label="LeaveType"
                    :options = leaveTypeOptions
                  />
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseSelector v-model="criteria.leaveStatus"
                                  :v="$v.criteria.leaveStatus"
                                  slug="leaveStatus"
                                  label="LeaveStatus"
                                  :options = leaveStatusOptions
                    />
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col cols="12" lg="4">
                    <BaseDateInput v-model="criteria.effectiveStartDateStart"
                                   :v="$v.criteria.effectiveStartDateStart"
                                   label="Effective Start Date Start"
                                   slug="start-start-date"/>
                </b-col>

                <b-col cols="12" lg="4">
                    <BaseDateInput v-model="criteria.effectiveStartDateEnd"
                                   :v="$v.criteria.effectiveStartDateEnd"
                                   label="Effective Start Date End"
                                   slug="start-end-date"/>
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col cols="12" lg="4">
                    <BaseDateInput v-model="criteria.effectiveEndDateStart"
                                   :v="$v.criteria.effectiveEndDateStart"
                                   label="Effective End Date Start"
                                   slug="end-start-date"/>
                </b-col>

                <b-col cols="12" lg="4">
                    <BaseDateInput v-model="criteria.effectiveEndDateEnd"
                                   :v="$v.criteria.effectiveEndDateEnd"
                                   label="Effective End Date End"
                                   slug="end-end-date"/>
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col cols="12" lg="4">
                    <BaseDateInput v-model="criteria.certificationStartDate"
                                   :v="$v.criteria.certificationStartDate"
                                   label="Certification Deadline Start"
                                   slug="cert-start-date"/>
                </b-col>

                <b-col cols="12" lg="4">
                    <BaseDateInput v-model="criteria.certificationEndDate"
                                   :v="$v.criteria.certificationEndDate"
                                   label="Certification Deadline End"
                                   slug="cert-end-date"/>
                </b-col>
            </b-row>
            <hr/>
            <b-row class="mb-3">
              <b-col>
                <b-button type="button" variant="primary" @click="search">
                   <b-spinner small v-show="loading" class="mr-2"></b-spinner>Search</b-button>
                  <b-button type="button" variant="secondary" @click="clear">Clear</b-button>
                <b-button variant="outline-primary" @click="download" class="ml-5">
                    <b-spinner small v-show="loadingDownload" class="mr-2"></b-spinner>
                    Download Spreadsheet
                </b-button>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                  <b-table hover small responsive show-empty
                           :fields="fields"
                           :items="requests"
                           :busy="loading">
                      <template #table-caption></template>
                      <template v-slot:cell(actions)="row">
                          <b-button size="sm" @click="viewItem(row.item)" class="mr-1">
                              view
                          </b-button>
                      </template>
                      <template v-slot:no-data>
                          <p>No leave requests found.</p>
                      </template>

                      <template v-slot:empty="scope">
                          <p>No leave requests found.</p>
                      </template>

                      <div slot="table-busy" class="text-center text-danger my-2">
                          <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
                          <strong>Loading, Please Wait...</strong>
                      </div>

                  </b-table>
              </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from "axios"
import { required } from 'vuelidate/lib/validators'
import fileDownload  from 'js-file-download'
import { commonOptions } from '@/mixins/commonOptions.js'
import pageTitle from '@/mixins/pageTitle'
import BaseSelector from "../components/BaseSelector";
import BaseDateInput from "../components/BaseDateInput";

export default {
  title: 'HRM Leave Request Query',
  data: () => ({
    loading: false, 
    loadingDownload: false,

    filter: null,

    criteria: {
      leaveType: null,
      leaveStatus: null,
      effectiveStartDateStart: null,
      effectiveStartDateEnd: null,
      effectiveEndDateStart: null,
      effectiveEndDateEnd: null,
      certificationStartDate: null,
      certificationEndDate: null,
    },
    requests: [],
    fields: [
        {key: 'division', sortable: true, label: 'Division'},
        {key: 'employeeId', sortable: true, label: 'EIN'},
        {key: 'employeeName', sortable: true, label: 'Employee Name'},
        {key: 'statusLastDateTime', sortable: true, label: 'Request Received'},
        {key: 'lastUpdatedDateTime', sortable: true, label: 'Last Updated Date'},
        {key: 'leaveType', sortable: true, label: 'Type of Leave'},
        {key: 'leaveDecision', sortable: true, label: 'Leave Decision'},
        {key: 'actions', label: 'Actions'},
    ],
    leaveStatusOptions: [
        { value: '01', text: 'New' },
        { value: '02', text: 'Approved' },
        { value: '22', text: 'Closed' },
        { value: '29', text: 'PPL Leave - Transactions' },
        { value: '30', text: 'PPL Leave - Payroll' },
        { value: '31', text: 'FMLA Leave - Payroll' },
    ],
  }),
  components: {
      BaseDateInput,
      BaseSelector,
  },
  mixins: [
    commonOptions,
    pageTitle
  ],
  validations: {
    criteria: {
      leaveType: { required: false },
      leaveStatus: { required: false },
      effectiveStartDateStart: { required: false },
      effectiveStartDateEnd: { required: false },
      effectiveEndDateStart: { required: false },
      effectiveEndDateEnd: { required: false },
      certificationStartDate: { required: false },
      certificationEndDate: { required: false },
    }
  },
  methods: {
    clear() {
        this.criteria = {
            leaveType: null,
            leaveStatus: null,
            effectiveStartDateStart: null,
            effectiveStartDateEnd: null,
            effectiveEndDateStart: null,
            effectiveEndDateEnd: null,
            certificationStartDate: null,
            certificationEndDate: null,
        }
        this.requests = []
    },
    search() {
          this.loading = true
          this.requests = []
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/report/leave-search`, this.criteria)
          .then(response => { 
            this.requests = response.data
            this.loading = false
          })
    },
    download() {
      this.loadingDownload = true
      let requestConfig = {
        responseType: 'blob'       
      }
      
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/export/leave/search`, this.criteria, requestConfig)
      .then(response => { 
        this.loadingDownload = false
        fileDownload(response.data, 'hrm-requests.xlsx')
      })
    },
    viewItem(item){
        this.$router.push({ name: 'view', params: { id: item.id } })
    }
  }
 }
</script>

<style>

</style>